<template>
  <div>
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>

    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 2fr 5fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
    >
      <section
        class="Polaris-Box"
        style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
      >
        <div
          class="Polaris-BlockStack"
          style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
        >
          <h3 class="Polaris-Text--root Polaris-Text--headingMd">
            Manual Message Sending Preference
          </h3>
          <p class="Polaris-Text--root Polaris-Text--bodyMd">
            You can either choose to send manual messages using whatsapp web or
            desktop app
          </p>
        </div>
      </section>

      <div
        class="Polaris-ShadowBevel"
        style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
      >
        <div
          class="Polaris-Box"
          style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
        >
          <div class="Polaris-LegacyStack Polaris-LegacyStack--vertical">
            <div
              class="Polaris-LegacyStack__Item"
              v-for="(option, index) of options"
              :key="index"
            >
              <div>
                <label
                  class="Polaris-Choice Polaris-RadioButton__ChoiceLabel"
                  :for="`pref_${index}`"
                >
                  <span class="Polaris-Choice__Control">
                    <span class="Polaris-RadioButton">
                      <input
                        :id="`pref_${index}`"
                        name="notification-method"
                        type="radio"
                        class="Polaris-RadioButton__Input"
                        :value="option.value"
                        v-model="sendMessagesUsingDesktopApp"
                      />
                      <span class="Polaris-RadioButton__Backdrop"></span>
                    </span>
                  </span>
                  <span class="Polaris-Choice__Label">
                    <span class="Polaris-Text--root Polaris-Text--bodyMd">{{
                      option.label
                    }}</span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sendMessagesUsingDesktopApp: false,
      initialValue: false,
      $uiSaveBar: null,
      options: [
        {
          label: "Whatsapp Web",
          value: false
        },
        {
          label: "Whatsapp Desktop App",
          value: true
        }
      ]
    };
  },
  computed: {
    hasUnsavedChanges() {
      return this.sendMessagesUsingDesktopApp !== this.initialValue;
    }
  },
  watch: {
    hasUnsavedChanges(newVal) {
      if (newVal) {
        this.$uiSaveBar.show();
      } else {
        this.$uiSaveBar.hide();
      }
    }
  },
  created() {
    const store = this.$store.getters.getStore;
    console.log("hello", store);
    this.sendMessagesUsingDesktopApp = store.sendMessagesUsingDesktopApp;
    this.initialValue = store.sendMessagesUsingDesktopApp;
  },
  mounted() {
    this.$uiSaveBar = document.getElementById("my-save-bar");
  },
  methods: {
    onSaveBarSaveClicked() {
      this.updatePreference(this.sendMessagesUsingDesktopApp);
      this.$uiSaveBar.hide();
      this.initialValue = this.sendMessagesUsingDesktopApp;
    },
    onSaveBarDiscardClicked() {
      this.sendMessagesUsingDesktopApp = this.initialValue;
      this.$uiSaveBar.hide();
    },
    updatePreference(value) {
      this.$store
        .dispatch("updatePreference", {
          requestParams: {
            sendMessagesUsingDesktopApp: value
          }
        })
        .then(() => {
          this.$store.dispatch("getConfig");
          this.$store.dispatch("showNotification", {
            text: "Preferences updated successfully"
          });
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            text: "Failed to update preferences"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
